import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class ApiService {

  baseUrl =  environment.base_url;

  constructor(private http: HttpClient) { }

  get(relativeUrl: string): Observable<any> {
    return this.http.get(this.baseUrl + relativeUrl);
  }

  post(relativeUrl: string, body: any): Observable<any> {
    return this.http.post(this.baseUrl + relativeUrl, body);
  }

  getCitizenData(relativeUrl: string): Observable<any> {
    return this.http.get(environment.citizen_base_url + relativeUrl);
  }

  postCitizenData(relativeUrl: string, body: any): Observable<any> {
    return this.http.post(environment.citizen_base_url + relativeUrl, body);
  }

  getBlobFileFromServer(relativeUrl: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type','*');
    return this.http.get(relativeUrl, { headers : headers,  responseType: 'blob' });
  }
}
